import React, { useEffect, useRef, useState } from "react";
import { v4 as uuid } from "uuid";

import "./dmView.scss";
import DMContainer from "./DMContainer";
import {
  DELETE_DOCTOR_ADDED_DRUG,
  GET_DRUG_FOR_AUTOFILL,
  GET_DRUG_INSTRUCTION_LIST,
} from "../../ERXViewApiHandler/apiConstants";
import NotificationModal from "../../../UI Component/Notification/NotificationModal";
import AddIcon from "../../../../assets/add_drug.svg";
import useDebounce from "../../common/debounce";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import TitleWithBorder from "../../common/TitleWithBorder";
import { CUSTOM_BUTTON_STATUS } from "../../ERXConstants/constants";
import {
  c2cGetApiHandler,
  c2cPostApiHandler,
} from "../../../../Util/c2cApiHandler";

const DMView = (props) => {
  const {
    element,
    drugList,
    drugsSuggestionList,
    handleDrugData,
    prescription_id,
    frequencyOptions,
    frequencyDetailsOptions,
    durationOptions,
    quantityOptions,
    unitOptions,
    updateDrugOrMedication,
    getGetDrugsDataAPI,
    handleApiLoaders,
    setIsTemplateSelected,
  } = props;
  const [drugOption, setDrugOption] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteDoctorDrugId, setDeleteDoctorDrugId] = useState("");
  const [drugIndx, setDrugIndx] = useState(0);
  const [val, setVal] = useState("");
  const [isScroll, setIsScroll] = useState(false);
  const [instructionValue, setInstructionValue] = useState({
    id: "",
    value: "",
  });
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const debouncedForDrug = useDebounce(drugList, 500);
  const debouncedForSearch = useDebounce(val, 500);
  const debounceForInstructionSearch = useDebounce(instructionValue, 500);
  const [suggestionList, setSuggestionList] = useState([]);
  const [instructuionOptions, setInstructionOptions] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [maxApiCall, setMaxApiCall] = useState(1);
  const searchTypeRef = useRef("search");
  const [drugInformation, setDrugInformation] = useState({});
  const [disableAddNewBtn, setDisableAddNewBtn] = useState(false);
  const [drugApiFlag, setDrugApiFlag] = useState(true);
  const [tempDrugOptions, setTempDrugOptions] = useState([]);
  const formRefs = useRef([]);
  // Lifecycle Methods ===>

  useEffect(() => {
    if (debouncedForDrug?.call_api) {
      updateDrugOrMedication(null, debouncedForDrug?.templateSelected);
    }
  }, [debouncedForDrug]);

  useEffect(() => {
    if (val) setDrugOption(tempDrugOptions);
    else setDrugOption([]);
  }, [tempDrugOptions]);

  useEffect(() => {
    if (drugApiFlag && val?.trim()?.length > 0) {
      let reqPayload = {
        doctor_id: userId,
        search_field: "drug_name",
        search_text: val?.trim(),
        user_type: "1",
        page_no: pageNo,
        page_size: "20",
      };
      getDrugForAutoFillAPI(reqPayload);
    }
  }, [debouncedForSearch, pageNo, isScroll, drugApiFlag]);

  useEffect(() => {
    if (debounceForInstructionSearch?.value?.length > 0) {
      let reqParams = {
        search_string: instructionValue?.value,
        doctor_id: userId,
      };
      getDrugInstructionListApi(reqParams);
    } else {
      setInstructionOptions([]);
    }
  }, [debounceForInstructionSearch]);

  useEffect(() => {
    let recommendationList = JSON.parse(JSON.stringify(drugsSuggestionList));
    recommendationList.forEach((item) => {
      let data = drugList?.value?.filter(
        (drug) =>
          drug.drug?.toLowerCase()?.trim() ===
            item.drug?.toLowerCase()?.trim() &&
          drug.frequency_extended?.title?.toLowerCase() ===
            item.frequency_extended?.title?.toLowerCase() &&
          drug.frequency_extended?.details?.toLowerCase() ===
            item.frequency_extended?.details?.toLowerCase() &&
          drug.duration?.toLowerCase() === item.duration?.toLowerCase() &&
          !drug.deleted_at &&
          drug.id
      );
      item.selected = data?.length !== 0;
    });
    setSuggestionList([...recommendationList]);
  }, [drugsSuggestionList, drugList]);

  // <===

  const handleInstructionChange = (tempIndex, value, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);
    setInstructionValue({ id: index, value: value?.trim() });
    data[index].instructions = value;
    data[index].instructions_slug = null;

    if (value?.trim()?.length === 0) {
      data[index].instruction_button_status = "";
    }
    handleDrugData(true, data);
  };

  const handleDeleteDrug = (index, drugInfo) => {
    let data = [...drugList.value];
    let tempInd = data.findIndex((obj) => obj.id === drugInfo?.id);
    if (data[tempInd]?.id) {
      data[tempInd].deleted_at = "NOW()";
      updateDrugOrMedication([...data]);
    }
    handleDrugData(false, data);

    setDrugIndx(0);
  };

  const handleAddDrug = (item) => {
    if (!disableAddNewBtn) {
      setVal("");
      handleDrugOpion();
    }
    setInstructionValue({ id: "", value: "" });
    let data = [...drugList.value];
    let obj = {
      id: uuid(),
      appointment_prescription_id: prescription_id,
      drug: "",
      frequency: "",
      duration: "",
      instructions: "",
      drug_master_id: null,
      frequency_extended: { title: "", details: "", slug: "" },
      deleted_at: null,
      frequencyOptions: frequencyOptions,
      frequencyDetailsOptions: frequencyDetailsOptions,
      durationOptions: durationOptions,
      instructions_slug: "",
      duration_slug: null,
      frequency_slug: null,
      drug_button_status: "",
      instruction_button_status: "",
    };

    if (item) {
      obj = {
        ...obj,
        ...(!item?.knowledge_base_drug_id &&
          !item?.drug_master_id && {
            drug_button_status: CUSTOM_BUTTON_STATUS.SAVE,
          }),
        ...(!item?.knowledge_base_id &&
          !item?.master_id &&
          item?.instructions && {
            instruction_button_status: CUSTOM_BUTTON_STATUS.SAVE,
          }),
      };
      obj = { ...obj, ...item, id: uuid() };
    }
    data.push(obj);
    handleDrugData(item ? true : false, [...data], item ? true : false);
    handleDrugOpion();
  };

  const handleDuration = (tempIndex, option, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);
    data[index].duration = option?.value;
    data[index].duration_slug = option?.duration_slug;
    handleDrugData(true, JSON.parse(JSON.stringify([...data])));
  };

  const handleDrugDetails = (tempIndex, option, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);
    data[index].frequency_extended.details = option?.value;
    data[index].frequency =
      data[index].frequency_extended?.title +
      ", " +
      (option?.value ? option?.value : "");
    data[index].frequency_slug = option?.frequency_slug;
    handleDrugData(true, [...data]);
  };

  const handleFrequency = (tempIndex, option, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);
    data[index].frequency_extended.title = option?.value;
    data[index].frequency =
      (option?.value ? option?.value : "") +
      ", " +
      data[index].frequency_extended?.details;
    handleDrugData(true, [...data]);
  };

  const handleFrequencyInput = (tempIndex, value, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);

    data[index].frequency_extended.title = value;
    handleDrugData(true, [...data]);
  };

  const handleDrugOpion = () => {
    setDrugOption([]);
  };

  const handleDrugSelect = (tempIndex, value, drugInfo) => {
    setPageNo(1);
    searchTypeRef.current = "search";
    setVal("");
    //setting to "" to avoid search api call after selecting drug from dropdown
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);
    data[index].drug = value?.drug_name;
    data[index].short_name = value?.short_name?.trim();
    data[index].drug_master_id = value?.drug_master_id
      ? value?.drug_master_id
      : null;
    data[index]["knowledge_base_drug_id"] = value?.knowledge_base_drug_id
      ? value?.knowledge_base_drug_id
      : null;
    data[index].drug_button_status =
      value?.knowledge_base_drug_id || value?.drug_master_id
        ? ""
        : value?.drug_button_status;
    handleDrugData(true, [...data]);
  };

  const getDrugForAutoFillAPI = (reqPayload) => {
    setDisableAddNewBtn(true);
    handleApiLoaders("drugSearch", true);
    const drugListResponse = c2cGetApiHandler(
      GET_DRUG_FOR_AUTOFILL,
      reqPayload
    ); //Fetch API Data
    drugListResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          let drugs_from_database;
          if (res.data?.data?.length > 0) {
            let count = res.data?.total_count;
            let maxCount = Math.ceil(count / 20);
            setMaxApiCall(maxCount);
            let data_db = [];
            res.data.data.map((drugsData, indx) => {
              let obj = {};
              obj["drug_id"] = drugsData?._id;
              obj["drug_name"] = drugsData?._source["drug_name"];
              obj["label"] = drugsData?._source?.drug_name;
              obj["packaging"] = drugsData?._source["packaging"];
              obj["salt_composition"] = drugsData?._source["salt_composition"];
              obj["drug_master_id"] =
                drugsData?._source?.source === "master" ? drugsData?._id : "";
              obj["short_name"] = drugsData?._source?.short_name
                ? `${drugsData._source.short_name} `
                : "";

              data_db.push(obj);
            });
            drugs_from_database = data_db;
          } else {
            drugs_from_database = [];
          }
          let allDrugList = [...drugs_from_database];
          let data = [...drugList?.value];
          let drugIndx = data.findIndex(
            (info) => info?.id === drugInformation?.id
          );

          if (allDrugList) {
            let filteredData = allDrugList.filter(
              (drug_data) =>
                drug_data?.drug_name?.toLowerCase()?.trim() ===
                reqPayload?.search_text?.toLowerCase()?.trim()
            );
            if (filteredData?.length == 0) {
              data[drugIndx]["knowledge_base_drug_id"] = null;
            } else {
              data[drugIndx]["knowledge_base_drug_id"] = !filteredData[0]
                ?.drug_master_id
                ? filteredData[0].drug_id
                : null;
              if (filteredData[0]?.drug_master_id) {
                data[drugIndx]["drug_master_id"] =
                  filteredData[0].drug_id ?? filteredData[0]?.drug_master_id;
              }
            }
            if (
              data[drugIndx]?.knowledge_base_drug_id ||
              data[drugIndx]?.drug_master_id
            ) {
              data[drugIndx]["drug_button_status"] = "";
            } else {
              data[drugIndx]["drug_button_status"] = CUSTOM_BUTTON_STATUS.SAVE;
            }
            if (!data[drugIndx]?.drug) {
              data[drugIndx]["drug_button_status"] = "";
            }

            if (data[drugIndx]?.drug === val && isScroll) {
              setVal("");
            }
            // handleDrugData(false, [...data]);
            setDisableAddNewBtn(false);
          }
          if (searchTypeRef.current === "pagination") {
            setTempDrugOptions([...drugOption, ...drugs_from_database]);
          } else {
            setTempDrugOptions([...drugs_from_database]);
          }
        } else {
          handleApiLoaders("drugSearch", false);
          setDisableAddNewBtn(false);
          setVal("");
        }
      } else {
        handleApiLoaders("drugSearch", false);
        setDisableAddNewBtn(false);
      }
    });
  };

  const getDrugInstructionListApi = (reqParams) => {
    const drugInstructionListResponse = c2cGetApiHandler(
      GET_DRUG_INSTRUCTION_LIST,
      reqParams
    ); //Fetch API Data
    drugInstructionListResponse.then(([res, error]) => {
      if (!error && res?.data?.statusCode === 200) {
        let data = [...drugList?.value];
        let instruction_list =
          res?.data?.data?.length > 0 ? res?.data?.data : [];

        let filteredData = instruction_list?.filter(
          (drug_data) =>
            drug_data?.title?.trim()?.toLowerCase() ===
            reqParams?.search_string?.trim()?.toLowerCase()
        );
        if (filteredData?.length === 0) {
          data[instructionValue?.id]["knowledge_base_id"] = null;
          data[instructionValue?.id]["master_id"] = null;
        } else {
          data[instructionValue?.id]["knowledge_base_id"] =
            filteredData[0].knowledge_base_id;
          if (filteredData[0]?.master_id) {
            data[instructionValue?.id]["master_id"] =
              filteredData[0]?.master_id;
          }
        }
        if (
          data[instructionValue?.id]?.knowledge_base_id ||
          data[instructionValue?.id]?.master_id
        ) {
          data[instructionValue?.id]["instruction_button_status"] = "";
        } else {
          data[instructionValue?.id]["instruction_button_status"] =
            CUSTOM_BUTTON_STATUS.SAVE;
        }

        if (!data[instructionValue?.id]?.instructions) {
          data[instructionValue?.id]["instruction_button_status"] = "";
        }
        setInstructionOptions(instruction_list);
      } else {
        setInstructionOptions([]);
      }
    });
  };

  const handleSearchDrug = (tempIndex, value, type, drugInfo) => {
    setDisableAddNewBtn(true);
    setIsScroll(false);
    searchTypeRef.current = type;
    let regex = /\s\s+/g;
    setVal(value);
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);

    if (index <= -1) return;
    data[index].drug = value?.trimStart()?.replace(regex, " ");
    data[index].drug_master_id = null;
    if (value?.trim()?.length === 0) {
      setDisableAddNewBtn(false);
      data[index].drug_button_status = "";
    }
    handleDrugData(true, data);
    if (value?.trim()?.length === 0) {
      handleDrugOpion();
    }
  };

  const handleOnScrollDropdown = (e, tempIndex, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);
    let bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (
      e.target.scrollHeight - Math.round(e.target.scrollTop) + 1 ===
      e.target.clientHeight
    ) {
      bottom = true;
    }
    if (
      e.target.scrollHeight - Math.round(e.target.scrollTop) - 1 ===
      e.target.clientHeight
    ) {
      bottom = true;
    }
    if (bottom) {
      if (pageNo < maxApiCall) {
        setIsScroll(true);
        setPageNo(pageNo + 1);
        handleSearchDrug(index, val, "pagination");
      }
    }
  };

  const handleDeleteDrugOption = (e, item) => {
    e.stopPropagation();
    setDeleteDoctorDrugId(item?.drug_id);
    setShowDeleteModal(true);
  };

  const handleDeleteCancel = () => {
    setDeleteDoctorDrugId("");
    setShowDeleteModal(false);
    setTempDrugOptions([]);
  };

  const handleDeleteSuccess = () => {
    let reqPayload = {
      doctor_id: userId,
      search_field: "drug_name",
      item_id: deleteDoctorDrugId,
      user_type: "1",
    };
    const deleteDrugResponse = c2cPostApiHandler(
      DELETE_DOCTOR_ADDED_DRUG,
      reqPayload
    ); //Fetch API Data
    deleteDrugResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          getGetDrugsDataAPI(prescription_id, true);
          handleDeleteCancel();
        }
      }
    });
  };

  const handleDrugIndx = (data, drugInfo) => {
    setDrugIndx(data);
    setDrugInformation(drugInfo);
  };

  const handleKnowledgeBaseDrug = (drug) => {
    let data = [...drugList.value];
    let index = data.findIndex(
      (drugElement) => drugElement.id === drug?.drug_id
    );
    if (index > -1) {
      data[index]["knowledge_base_drug_id"] = drug?.knowledge_base_drug_id;
      data[index]["drug_button_status"] = drug?.drug_button_status ?? "";
    }
    handleDrugData(true, data);
  };

  const handleKnowledgeBaseInstruction = (drug) => {
    let data = [...drugList.value];
    let index = data.findIndex((elementId) => elementId.id === drug?.drug_id);
    if (index > -1) {
      data[index]["knowledge_base_id"] = drug?.knowledge_base_id;
      data[index]["instruction_button_status"] =
        drug?.instruction_button_status ?? "";
    }
    handleDrugData(true, data);
  };

  // Actions ===>
  const handelClickAway = () => {
    setPageNo(1);
    searchTypeRef.current = "search";
  };

  const handleClickTitle = (item) => {
    if (!item.selected) {
      setIsTemplateSelected(true);
      handleAddDrug(item);
    }
  };

  const addDrugBtnClicked = () => {
    handleAddDrug();
  };

  const handleInstructionSelect = (tempIndex, selectedData, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);
    data[index].instructions = selectedData?.title;
    data[index].instructions_slug = selectedData?.slug;
    if (selectedData?.knowledge_base_id) {
      data[index].knowledge_base_id = selectedData?.knowledge_base_id;
    } else if (selectedData?.master_id) {
      data[index].master_id = selectedData?.master_id;
    }
    if (selectedData?.knowledge_base_id || selectedData?.master_id) {
      data[index]["instruction_button_status"] = "";
    } else {
      data[index]["instruction_button_status"] = CUSTOM_BUTTON_STATUS.SAVE;
    }
    handleDrugData(true, [...data]);
  };

  const handleInstructionOptions = () => {
    setInstructionOptions([]);
  };

  const handleQuantity = (tempIndex, value, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);
    data[index].quantity = value;
    handleDrugData(true, JSON.parse(JSON.stringify([...data])));
  };

  const handleUnit = (tempIndex, value, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);

    data[index].unit = value;
    handleDrugData(true, JSON.parse(JSON.stringify([...data])));
  };

  const handleDurationInput = (tempIndex, value, drugInfo) => {
    let data = [...drugList.value];
    let index = data.findIndex((obj) => obj.id === drugInfo?.id);
    data[index].duration = value;
    data[index].duration_slug = "";
    handleDrugData(true, JSON.parse(JSON.stringify([...data])));
  };

  // <===

  // Display UI ===>

  const renderAddDrugButton = () => {
    return (
      <button
        className={"add-column-btn py-2"}
        onClick={() => {
          addDrugBtnClicked();
        }}
      >
        <img src={AddIcon} alt="" className="mx-2" />
        Add New Drug{" "}
      </button>
    );
  };

  const displayDrugsSuggestionList = () => {
    return (
      <div
        className="drugs-suggestion-list"
        style={{ marginTop: drugList?.value?.length !== 0 ? "" : "0" }}
      >
        {suggestionList.map((item) => (
          <TitleWithBorder
            key={item.id}
            title={`${item?.short_name ? `${item?.short_name} ` : ""}${
              item.drug
            }`}
            hoverTitleSize={30}
            selected={item.selected}
            handleClick={() => handleClickTitle(item)}
          />
        ))}
      </div>
    );
  };

  const displayDrugListUI = () => {
    let filteredList = drugList?.value?.filter(
      (item) => !item?.deleted_at && item?.id
    );

    if (formRefs.current.length !== filteredList.length) {
      formRefs.current = filteredList.map(
        (_, formIndex) =>
          formRefs.current[formIndex] ||
          [...Array(7)].map(() => React.createRef())
      );
    }

    return (
      <>
        {" "}
        {filteredList?.map((drugInfo, index) => (
          <div
            key={drugInfo?.id}
            style={{
              border: "1px solid #C9C9C980",
              borderRadius: "5px",
              marginBottom: "10px",
            }}
          >
            <DMContainer
              element_id={element.name}
              index={index}
              drugDetails={drugInfo}
              frequencyOptions={frequencyOptions}
              frequencyDetailsOption={frequencyDetailsOptions}
              durationOptions={durationOptions}
              drugOption={drugOption}
              quantityOptions={quantityOptions}
              unitOptions={unitOptions}
              instructuionOptions={instructuionOptions}
              prescription_id={prescription_id}
              handleInstructionChange={(index, value) =>
                handleInstructionChange(index, value, drugInfo)
              }
              handleDeleteDrug={(index) => handleDeleteDrug(index, drugInfo)}
              handleDuration={(index, option) =>
                handleDuration(index, option, drugInfo)
              }
              handleDrugDetails={(index, option) =>
                handleDrugDetails(index, option, drugInfo)
              }
              handleFrequency={(index, option) =>
                handleFrequency(index, option, drugInfo)
              }
              handleFrequencyInput={(index, value) =>
                handleFrequencyInput(index, value, drugInfo)
              }
              handleSearchDrug={(index, value, type) => {
                setPageNo(1);
                handleSearchDrug(index, value, type, drugInfo);
              }}
              handleDrugOpion={handleDrugOpion}
              handleDrugSelect={(index, value) =>
                handleDrugSelect(index, value, drugInfo)
              }
              handleDeleteDrugOption={handleDeleteDrugOption}
              handleDrugIndx={(index) => handleDrugIndx(index, drugInfo)}
              drugIndx={drugIndx}
              handleKnowledgeBaseDrug={handleKnowledgeBaseDrug}
              onSelect={(index, selectedData) =>
                handleInstructionSelect(index, selectedData, drugInfo)
              }
              handleInstructionOptions={handleInstructionOptions}
              handleKnowledgeBaseInstruction={handleKnowledgeBaseInstruction}
              handleQuantity={(index, value) =>
                handleQuantity(index, value, drugInfo)
              }
              handleUnit={(index, value) => handleUnit(index, value, drugInfo)}
              handleDurationInput={(index, value) =>
                handleDurationInput(index, value, drugInfo)
              }
              handleOnScrollDropdown={(e) => {
                handleOnScrollDropdown(e, index, drugInfo);
              }}
              setPageNo={setPageNo}
              handelClickAway={handelClickAway}
              formRefs={formRefs}
              setDrugApiFlag={setDrugApiFlag}
              drugApiFlag={drugApiFlag}
            />
          </div>
        ))}
      </>
    );
  };

  // <===

  return (
    <div className={`dm-main-view`} id={element.name}>
      <div className="drug-list">{displayDrugListUI()}</div>
      {displayDrugsSuggestionList()}
      <div
        className="d-flex justify-content-end"
        style={{
          borderTop: "1px solid #C9C9C980",
          padding: "5px 10px 0px",
          margin: "0px -10px",
        }}
      >
        {drugList?.value?.length >= 30 ? null : renderAddDrugButton()}
      </div>
      {showDeleteModal && (
        <NotificationModal
          content={{
            type: "success",
            messagetype: "",
            button: true,
            title: "Delete Saved Input",
            icon: "fa-file-text",
            message: "Are you sure you want to delete this input?",
            button2: true,
            classNameButton1: "button1",
            classNameButton2: "button2",
          }}
          cancelHandler={handleDeleteCancel}
          successHandler={handleDeleteSuccess}
        />
      )}
    </div>
  );
};

export default DMView;
